import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { ContactFormData, ContactFormErrors } from "@/types/contact";

interface ContactFormProps {
  initialData?: Partial<ContactFormData>;
  onSubmit: (data: ContactFormData) => void;
  onCancel: () => void;
  isEditing?: boolean;
}

export const ContactForm = ({
  initialData,
  onSubmit,
  onCancel,
  isEditing = false,
}: ContactFormProps) => {
  const [formData, setFormData] = React.useState<ContactFormData>({
    name: initialData?.name || "",
    phone: initialData?.phone || "",
    instagram: initialData?.instagram || "",
    whatsapp: initialData?.whatsapp || "",
    notes: initialData?.notes || "",
    source: initialData?.source || "manual",
  });

  const [errors, setErrors] = React.useState<ContactFormErrors>({});

  const validateForm = (): boolean => {
    const newErrors: ContactFormErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Nome é obrigatório";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(formData);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name as keyof ContactFormData]) {
      setErrors((prev) => ({
        ...prev,
        [name]: undefined,
      }));
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <Input
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Nome"
          className={errors.name ? "border-red-500" : ""}
        />
        {errors.name && (
          <span className="text-sm text-red-500">{errors.name}</span>
        )}
      </div>

      <Input
        name="phone"
        value={formData.phone}
        onChange={handleChange}
        placeholder="Telefone"
      />

      <Input
        name="instagram"
        value={formData.instagram}
        onChange={handleChange}
        placeholder="Instagram"
      />

      <Input
        name="whatsapp"
        value={formData.whatsapp}
        onChange={handleChange}
        placeholder="WhatsApp"
      />

      <Textarea
        name="notes"
        value={formData.notes}
        onChange={handleChange}
        placeholder="Observações"
      />

      <div className="flex justify-end space-x-2">
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancelar
        </Button>
        <Button type="submit">{isEditing ? "Atualizar" : "Salvar"}</Button>
      </div>
    </form>
  );
};